import curriculum from './cs2013.json' // Note: this will bundle the file with the app

const areas = curriculum.areas;
const version = curriculum.version;

// We had to version our curriculum file,
// because we had some errors in it initially,
// and others already had created selections
// using the IDs of that erroneous cc13.json.

// Now we use the following versioning approach:
// - store the version of the curriculum in the cc13.json file (just for reference)
// - store the version of the curriculum in each selection (necessary)
// Note that v1 (the initial version), does not store the version ID anywhere.
// Thus, if a selection doesn't have a version ID, it is v1.

// At import or hydration of selections:
// - we check the version
// - if the selection version is equal to the cc13.json version,
//   we import as is
// - if the selection version is older than the cc13.json version,
//   we apply the update functions (one by one)

function upgradeSelectionIfNeeded(selection) {
  //console.log("upgradeSelectionIfNeeded()", selection);
  //console.log("selection.version:", selection.version);
  const selectionVersion = selection.version || 1;
  //console.log("selectionVersion:", selectionVersion);
  if (selectionVersion>curriculum.version) {
    //console.log("WARNING: Curriculum version of selection is greater than curriculum version of this application.");
    return selection;
  } else if (selectionVersion<curriculum.version) {
    return upgradeSelection(selection);
  } else {
    // same version
    return selection;
  }
}

function upgradeSelection(selection) {
  const selectionVersion = selection.version || 1;
  for (let v=selectionVersion; v<curriculum.version; v++) {
    //console.log("upgrade from v"+v+" to v"+(v+1));
    // Note: upgraders operate in-place (they mutate the selection object)
    upgraders[v](selection);
    selection.version = v+1;
  }
  return selection;
}

const upgraders = [
  null, // upgrade from v0 to v1 (there is no v0)
  upgradeFromV1ToV2,
]


function upgradeFromV1ToV2(selection) {
  //console.log("upgradeFromV1ToV2()", selection);
  // HCI4: merge topic 6 and 7
  selection.items = mergeItems(selection.items, 'HCI4.6', 'HCI4.7', 'HCI4.6');
  // rename all HCI4.x, where x>7, to HCI4.(x-1)
  selection.items = decrementTopicIds(selection.items, 'HCI', '4', 7);
  // SP5: merge topic 3 and 4
  selection.items = mergeItems(selection.items, 'SP5.3', 'SP5.4', 'SP5.3');
  selection.items = decrementTopicIds(selection.items, 'SP', '5', 4);
}

function mergeItems(items, fqid1, fqid2, targetFqid) {
  const newItems = {...items};
  const item1 = newItems[fqid1];
  delete newItems[fqid1];
  const item2 = newItems[fqid2];
  delete newItems[fqid2];
  const newItem = mergeTwoItems(item1, item2);
  if (newItem) {
    newItems[targetFqid] = newItem;
  }
  return newItems;
}

const TOPIC_ID_RE = /^([A-Z]+)([0-9]+)\.([0-9]+)(\.[0-9]+)?(\.[0-9]+)?$/;
function decrementTopicIds(items, areaId, unitId, lowestNewTopicId) {
  const newItems = {};
  for (const fqid of Object.keys(items)) {
    const result = TOPIC_ID_RE.exec(fqid);
    if (result) {
      const _areaId = result[1];
      const _unitId = result[2];
      const _topicId = result[3];
      const _subtopicId = result[4];
      const _subsubtopicId = result[5];
      if (_areaId===areaId && _unitId===unitId && _topicId>lowestNewTopicId) {
        const newFqid = _areaId+_unitId+'.'+(_topicId-1)+(_subtopicId?_subtopicId:'')+(_subsubtopicId?_subsubtopicId:'');
        const item = items[fqid];
        delete items[fqid];
        newItems[newFqid] = item;
      }
    }
  }
  return {...items, ...newItems};
}


function mergeTwoItems(item1, item2) {
  if (item1 || item2) {
    return {...item2, ...item1};
  } else {
    return undefined;
  }
}



export {
  areas,
  version,
  upgradeSelectionIfNeeded,
  // export for testing only
  decrementTopicIds,
  mergeItems,
  mergeTwoItems,
  upgradeFromV1ToV2
}